import React from 'react';
import Select from 'react-select';
import { comum } from '../../../styles/Themes/light';
import { EditavelContainer, ViewModeText, EditModeContainer, ErrorMessage } from '../EditavelCommon/styles';
import { SelectContainer } from '../SelectEditavel/styles';
import { EstadosBrasileiros } from '../../Data/StatesData';

interface SelectEstadoEditavelProps {
    value: string | undefined;
    onChange: (value: string) => void;
    isEditing: boolean;
    label?: string;
    placeholder?: string;
    required?: boolean;
    error?: string;
    isSearchable?: boolean;
    disabled?: boolean;
    onBlur?: () => void;
}

const SelectEstadoEditavel: React.FC<SelectEstadoEditavelProps> = ({
    value,
    onChange,
    isEditing,
    label,
    placeholder = 'Selecionar',
    required = false,
    error,
    isSearchable = true,
    disabled = false,
    onBlur,
}) => {
    const selectedOption = EstadosBrasileiros.find(opt => opt.value === value) || null;

    const handleChange = (selectedOption: { value: string; label: string } | null) => {
        if (selectedOption) {
            onChange(selectedOption.value);
        } else {
            onChange('');
        }
    };

    const displayText = selectedOption ? selectedOption.label : 'N/A';

    if (disabled || !isEditing) {
        return (
            <EditavelContainer>
                <ViewModeText>
                    {displayText}
                </ViewModeText>
                {error && <ErrorMessage>{error}</ErrorMessage>}
            </EditavelContainer>
        );
    }

    if (isEditing) {
        return (
            <EditavelContainer>
                <EditModeContainer>
                    <SelectContainer>
                        <Select
                            value={selectedOption}
                            onChange={handleChange}
                            onBlur={onBlur}
                            options={EstadosBrasileiros}
                            placeholder={placeholder}
                            isSearchable={isSearchable}
                            styles={{
                                control: (provided: any, state: any) => ({
                                    ...provided,
                                    minHeight: '32px',
                                    height: '32px',
                                    borderRadius: '6px',
                                    boxShadow: 'none',
                                    cursor: 'pointer',
                                    border: error
                                        ? `1px solid ${comum.colors.primaryRed400}`
                                        : '1px solid #EAEEF3',
                                    '&:hover': {
                                        border: error
                                            ? `1px solid ${comum.colors.primaryRed400}`
                                            : `1px solid ${comum.colors.interfaceTextGray}`,
                                    },
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    height: '32px',
                                    padding: '0 8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'nowrap',
                                    minHeight: '32px',
                                }),
                                input: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    margin: 0,
                                    padding: 0,
                                    height: 'auto',
                                    alignSelf: 'center',
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: 'var(--c353a40)',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    margin: 0,
                                    lineHeight: '1.2',
                                    alignSelf: 'center',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: 'var(--c353a40)',
                                    fontSize: '14px',
                                    margin: 0,
                                    lineHeight: '1.2',
                                    padding: 0,
                                    alignSelf: 'center',
                                    position: 'relative',
                                    top: 'auto',
                                    transform: 'none',
                                }),
                                option: (base) => ({
                                    ...base,
                                    color: 'var(--c5a646e)',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                }),
                                indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '32px',
                                    alignItems: 'center',
                                    alignSelf: 'stretch',
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: '4px 8px',
                                    alignSelf: 'center',
                                }),
                                indicatorSeparator: () => ({
                                    display: 'none',
                                }),
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 3,
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 3,
                                }),
                            }}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: comum.colors.interfacePure100,
                                    primary50: comum.colors.interfacePure100,
                                    primary: comum.colors.interfacePure100,
                                },
                            })}
                            components={{
                                IndicatorSeparator: () => null,
                            }}
                        />
                    </SelectContainer>
                    {error && <ErrorMessage>{error}</ErrorMessage>}
                </EditModeContainer>
            </EditavelContainer>
        );
    }

    return (
        <EditavelContainer>
            <ViewModeText>
                {displayText}
            </ViewModeText>
            {error && <ErrorMessage>{error}</ErrorMessage>}
        </EditavelContainer>
    );
};

export default SelectEstadoEditavel;

